export class Validation {
    public static regex = {
        email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\u00B5-\u00FF\u3131-\uD79D\-0-9]+\.)+[a-zA-Z\u00B5-\u00FF\u3131-\uD79D]{2,}))$/,
        po: /(\b[p|P][\s]*\.?[o|O][\s]*[0-9]*?)\b/i,
        poBox: /[p|P][\s]*[o|O][\s]*[b|B][\s]*[o|O][\s]*[x|X][\s]*[a-zA-Z0-9]*|\b[P|p]+(OST|ost|o|O)?\.?\s*[O|o|0]+(ffice|FFICE)?\.?\s*[B|b][O|o|0]?[X|x]+\.?\s+[#]?(\d+)*(\D+)*\b/i,
        name: /^[A-Za-z ]+$/,
        lastName: /^[A-Za-z]+$/,
        userid: /^[a-zA-Z0-9À-ÖØ-öø-ÿ\-.'_,?!Â-ÿ]+$/u,
        phone: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
        number: /[0-9]/,
        address: /^[a-zA-Z0-9,-/.\s]+$/
    }
}
